// extracted by mini-css-extract-plugin
export default {"homepage":"Homepage_homepage__KWj5a","fade-in":"Homepage_fade-in__E72w-","dropdown":"Homepage_dropdown__kp4lF"};